import { format } from "date-fns";
import { DateRange } from "react-day-picker";

import cn from 'classnames';

import { CalendarIcon, XIcon } from "lucide-react";
import { Calendar } from "./Calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "./Popover";
import { HTMLAttributes, useEffect, useRef, useState } from "react";
import { getStoredFilters } from "@utils/filters";
import { PATIENT_KEY } from "@utils/constants";
import { useTranslation } from "react-i18next";

interface DatePicker extends Omit<HTMLAttributes<HTMLDivElement>, "onChange"> {
  onChange?: (dates: DateRange | undefined) => void;
  btnClass?: string;
}
export function DatePicker({
  className,
  onChange,
  btnClass = "",
}: DatePicker) {
  const [date, setDate] = useState<DateRange | undefined>()
  const lastDates = useRef<DateRange | undefined>()
  const {t} =useTranslation();

  const [open, setOpen] = useState<boolean>(false)

  useEffect(() => {
    if (!!date?.from && !!date?.to &&
      (JSON.stringify(lastDates.current) !== JSON.stringify(date))) {
      setOpen(false)
      lastDates.current = date
      onChange?.(date)
    }
  }, [date])

  const storedValue = getStoredFilters(PATIENT_KEY);

  useEffect(() => {
    if (storedValue.obito) {
      const format = { from: new Date(storedValue.obito.split(',')[0]), to: new Date(storedValue.obito.split(',')[1]) };
      setDate(format);
    }
  }, []);

  return (
    <div className={cn(className, 'w-fit')}>
      <Popover open={open}>
        <PopoverTrigger asChild onClick={() => { setOpen((prevState) => !prevState); setDate(undefined) }}>
          <button
            className={cn(
              open && "border-[#ED5939]",
              open && "shadow-[0_0_0_1px_#ED5939]",
              "min-w-fit inline-flex items-center whitespace-nowrap rounded-md text-sm text-grey-dark ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input bg-background hover:border-[#b3b3b3] px-4 py-2 justify-start text-left font-normal",
              " justify-start text-left font-normal h-[36px]",
              !date && "text-muted-foreground",
              btnClass
            )}
          >
            {date?.from ? (
              date.to ? (
                <>
                  {format(date.from, "LLL dd, y")} -{" "}
                  {format(date.to, "LLL dd, y")}
                </>
              ) : (
                format(date.from, "LLL dd, y")
              )
            ) : (
              <div className="flex flex-row justify-between align-center w-full items-center">
              <span className="text-grey-dark text-sm opacity-70 text-xs 2xl:text-sm">{t("filterByRelapse")}</span>
              <CalendarIcon className={`mr-2 ml-2 h-4 w-4 text-grey-dark text-orange`} />
              </div>
            )}

            {date?.from && date.to && <XIcon className="h-4 w-4 ml-auto text-grey-dark opacity-70" onClick={(ev) => {
              ev.stopPropagation()
              setDate(undefined)
              onChange?.(undefined)
            }} />}

          </button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start" onInteractOutside={() => { setOpen(false); setDate(lastDates.current) }}>
          <Calendar
            initialFocus
            mode="range"
            defaultMonth={date?.from || lastDates.current?.from}
            selected={date}
            onSelect={setDate}
            numberOfMonths={2}
          />
        </PopoverContent>
      </Popover>
    </div>
  )
}
